import React, { useState } from 'react';

function Interactivity() {
    const [lightboxSrc, setLightboxSrc] = useState(null);

    return (
        <div className="about-container p-8 max-w-4xl mx-auto pb-32">
            <h1 className="text-4xl font-bold mb-4">CHI 2025 Interactivity</h1>
            <p className="text-xl text-gray-600 mb-8">Popular Choice Honorable Mention Award (Top 5%)</p>

            <div className="space-y-8">
                <section>
                    <p className="text-lg text-gray-700 leading-relaxed">
                        EmoSync was presented at{' '}
                        <a
                            href="https://chi2025.acm.org/for-authors/interactivity/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 hover:underline"
                        >
                            CHI 2025 Interactivity
                        </a>{' '}
                        and received the <strong>Popular Choice Honorable Mention Award (Top 5%)</strong>.
                    </p>
                </section>

                <section>
                    <div>
                        <img
                            src={`${process.env.PUBLIC_URL}/emosync-award.jpg`}
                            alt="EmoSync team receiving the Popular Choice Honorable Mention Award at CHI 2025"
                            className="w-full rounded-lg shadow-md cursor-pointer hover:opacity-90 transition-opacity"
                            onClick={() => setLightboxSrc(`${process.env.PUBLIC_URL}/emosync-award.jpg`)}
                        />
                        <p className="text-sm text-gray-500 mt-2 text-center">Award ceremony at CHI 2025</p>
                    </div>
                </section>

                <section>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <img
                                src={`${process.env.PUBLIC_URL}/emosync-interactivity1.jpg`}
                                alt="EmoSync team presenting at the Interactivity booth"
                                className="w-full rounded-lg shadow-md cursor-pointer hover:opacity-90 transition-opacity"
                                onClick={() => setLightboxSrc(`${process.env.PUBLIC_URL}/emosync-interactivity1.jpg`)}
                            />
                            <p className="text-sm text-gray-500 mt-2 text-center">Team at the Interactivity booth</p>
                        </div>
                        <div>
                            <img
                                src={`${process.env.PUBLIC_URL}/emosync-interactivity2-blur.png`}
                                alt="Visitors interacting with the EmoSync demo at CHI 2025"
                                className="w-full rounded-lg shadow-md cursor-pointer hover:opacity-90 transition-opacity"
                                onClick={() => setLightboxSrc(`${process.env.PUBLIC_URL}/emosync-interactivity2-blur.png`)}
                            />
                            <p className="text-sm text-gray-500 mt-2 text-center">Visitors experiencing the EmoSync demo</p>
                        </div>
                    </div>
                </section>

                <section>
                    <div>
                        <img
                            src={`${process.env.PUBLIC_URL}/emosync-award-paper.jpg`}
                            alt="CHI 2025 Popular Choice Honorable Mention Award Certificate"
                            className="w-full rounded-lg shadow-md cursor-pointer hover:opacity-90 transition-opacity"
                            onClick={() => setLightboxSrc(`${process.env.PUBLIC_URL}/emosync-award-paper.jpg`)}
                        />
                    </div>
                </section>
            </div>

            {lightboxSrc && (
                <div
                    className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4"
                    onClick={() => setLightboxSrc(null)}
                >
                    <button
                        className="absolute top-4 right-4 text-white/80 hover:text-white transition-colors"
                        onClick={() => setLightboxSrc(null)}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                    <img
                        src={lightboxSrc}
                        alt="Enlarged view"
                        className="max-w-full max-h-full object-contain rounded-lg"
                        onClick={(e) => e.stopPropagation()}
                    />
                </div>
            )}
        </div>
    );
}

export default Interactivity;
